export const achievementData = {
    bio : "These are some of my achievements that I am most proud of !!",
    achievements : [
        {
            id : 1,
            title : 'Google Python Data Structures',
            details : 'Completed data structures & algorithms in Python. Accomplished File Management, OOPs concepts in Python.',
            date : 'May 06, 2022',
            field : 'DSA',
            image : 'https://res.cloudinary.com/h2camp/image/upload/v1663487663/samples/Google-Python_kekae3.png'
        },
        {
            id : 2,
            title : 'Google Hash Code 2022',
            details : 'Participated in and received the google hash code 2022 certificate and secured an AIR 361 out of 20,000+ teams.',
            date : 'Feb 24, 2022',
            field : 'Coding',
            image : 'https://res.cloudinary.com/h2camp/image/upload/v1663487759/samples/Google-HashCode_sqykxe.png'
        },
        {
            id : 3,
            title : 'CodeChef Certification',
            details : 'Achieved 529th Rank out of 29K Participants and Reached Snackdown 2021 Pre-elimination Round.',
            date : 'Dec 12, 2021',
            field : 'Coding',
            image : 'https://res.cloudinary.com/h2camp/image/upload/v1663488017/samples/CodeChef_serhv6.png'
        },
        {
            id : 4,
            title : 'Udemy Web Developer Certification',
            details : 'Completed the web developer bootcamp of MERN stack and designed a robust web application.',
            date : 'May 28, 2021',
            field : 'Web Development',
            image : 'https://res.cloudinary.com/h2camp/image/upload/v1663488992/samples/Udemy-Web_xgxdiz.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/